import { Editor } from '@tiptap/core';
import { DependencyList, useCallback, useEffect } from 'react';

export const useHotkeys = (
  editor: Editor,
  keyMap: Record<string, (e: KeyboardEvent) => void>,
  deps: DependencyList,
) => {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (keyMap[e.key]) {
        keyMap[e.key](e);
        // e.preventDefault();
        return true;
      }

      return false;
    },
    [keyMap],
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    const opts = { capture: true };

    editor.view.dom.addEventListener('keydown', handleKeyDown, opts);
    return () => {
      editor.view.dom.removeEventListener('keydown', handleKeyDown, opts);
    };
  }, [...deps, handleKeyDown]);

  return handleKeyDown;
};
